<template>
  <Expandable
    :content-to-display="mgnlProps.contentToDisplay"
    :default-mode="mgnlProps.defaultMode"
    :collapsed-text="mgnlProps.collapsedText"
    :expanded-text="mgnlProps.expandedText"
    :mode-text-color="mgnlProps.modeTextColor"
    :preview-height="mgnlProps.previewHeight"
    :data-ab-id="mgnlProps?.dataABId"
  />
</template>

<script lang="ts" setup>
import Expandable from './Expandable.vue';
import { ExpandableBuilder, WrapperProps } from '~/components/Shared/Expandable/Expandable.model';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps(WrapperProps);

const { modeTextColor } = toRefs(props);
const mgnlProps = {
  ...ExpandableBuilder.build(props),
  modeTextColor: magnoliaGetters.getHexColor(modeTextColor?.value),
};
</script>
